'use strict';

const tracking = require('../../modules/utils/tracking.utils');
const trackingAncillariesContinuance = require('../ancillaries_continuance');
const ADD_REMOVE_ENUM = new Odigeo.Enum(['add', 'remove']);
const ON_LOAD_JOIN_CHAR = '-';
const ON_LOAD_TRACKING_NOT_DISPLAYED_VALUE = 0;
const ON_LOAD_TRACKING_DISPLAYED_VALUE = 1;
const NO_POLICY = 'none';
const NO_PRODUCTS_TRACK = '0';
const LABEL = 'label';
const ADDITIONAL_PARAM_LIST = ['CONFIRMATION_SMS', 'BAGGAGE_ASSISTANCE', 'POSTED_TICKET', 'EVISA', 'ESTA', 'AUTO_CHECKIN'];
const EXTERNAL_INSURANCES_WITH_UNDERSCORE = [
    'CANX_AX01',
    'CANASS_AX02',
    'CANXDP_AX03',
    'FLEX_AX04',
    'HUB_AX05',
    'COMPRE_AX09',
    'UKCANX_AX10',
    'UKMULTI_AX12',
];
const PAGES = {
    details: 'pax',
    passengersinfo: 'pax',
    payment: 'pay',
    ancillaries: 'anc',
    canx: 'canx',
    insurance: 'ins',
    insurances: 'cov',
    selection: 'sel',
    flex: 'flex',
    servicepack: 'so',
    additions: 'ex',
};

const isDynpack = Odigeo.Utils.isRequestApp('dp');

const getPageLabel = (page) => {
    const flowSuffix = isDynpack ? 'dp' : 'fl';
    return `${PAGES[page]}${flowSuffix}`;
};

const productParamWithNoUnderscore = (param) => {
    return Odigeo._.includes(ADDITIONAL_PARAM_LIST, param) || Odigeo._.includes(EXTERNAL_INSURANCES_WITH_UNDERSCORE, param) ?
        param.replace(/_/g, '') :
        param;
};

const formatLabel = (label, category, policy, pageLabel, variables) => {
    category = Odigeo._.isUndefined(category) ? NO_POLICY : category;
    if (variables.priceWithoutInsurance) {
        label = label.replace(AncillariesTracking.PRICE_WITHOUT_INSURANCE, variables.priceWithoutInsurance);
    }
    if (variables.priceWithInsurance) {
        label = label.replace(AncillariesTracking.PRICE_WITH_INSURANCE, variables.priceWithInsurance);
    }
    return label.replace(AncillariesTracking.POLICY, productParamWithNoUnderscore(policy))
        .replace(AncillariesTracking.CATEGORY, category)
        .replace(AncillariesTracking.PAGE, pageLabel);
};

const getProductsFromSessionStorageByProductNameAndPage = (page, productName) => {
    const offeredPolicies = trackingAncillariesContinuance.getRegisteredOfferedPolicies(page);
    return Odigeo._.get(offeredPolicies, productName, []);
};

const prepareOnLoadTrackingArray = (length) => {
    const trackingOnLoadArray = [];
    for (let i = 0; i < length; i++) {
        trackingOnLoadArray.push(ON_LOAD_TRACKING_NOT_DISPLAYED_VALUE);
    }

    return trackingOnLoadArray;
};

const getActionWithSameTracking = (action) => {
    switch (action) {
        case 'smartContinuance':
            return 'continuance';
        default:
            return action;
    }
};

class AncillariesTracking {
    constructor(product,
        eventsDictionary,
        ancillaryLabelCategories,
        ancillaryLabelCategoryByPolicy,
        pages,
        variables,
        ancillaryLabelExpandedCategoriesIntoPolicies) {
        this.product = product;
        this.eventsDictionary = eventsDictionary || {};
        this.ancillaryLabelCategoryByPolicy = ancillaryLabelCategoryByPolicy || {};
        this.ancillaryLabelCategories = ancillaryLabelCategories || [];
        this.ancillaryLabelExpandedCategoriesIntoPolicies = ancillaryLabelExpandedCategoriesIntoPolicies || ancillaryLabelCategories || [];
        this.pages = pages || {};
        this.variables = variables || {};

        this.initOnLoadProductsTrackingArray();
    }

    trackEvent(type, id, pageName) {
        if (Odigeo._.isArray(id)) {
            if (Odigeo._.isEmpty(id)) {
                this.trackEvent(type, NO_PRODUCTS_TRACK, pageName);
            } else {
                Odigeo._.each(id, (item) => {
                    this.trackEvent(type, item, pageName);
                });
            }
        } else {
            const trackData = this.getTrackData(type, id, pageName);
            tracking.trackEvent(trackData.action, trackData.label, trackData.page);
        }
    }

    getPageToTrack() {
        const fragment = Odigeo.History.getFragment().replace(/^\/|\/$/g, '');
        const pageName = Odigeo.History.getPageNameFromFragment().split('/')[0];
        const backupPageName = Odigeo._.get(this.pages, `['${Odigeo.SessionScope.flow}']['${pageName}']`, pageName);
        const boundPage = Odigeo._.get(this.pages, `['${Odigeo.SessionScope.flow}']['${fragment}']`, backupPageName);
        return Odigeo._.isUndefined(boundPage) ? pageName : boundPage;
    }

    getTrackData(type, policy, pageName) {
        const category = Odigeo._.get(this.ancillaryLabelCategoryByPolicy, policy);
        const typeInfo = Odigeo._.get(this.eventsDictionary, type);
        const page = pageName || this.getPageToTrack();
        const pageLabel = getPageLabel(page);
        return {
            page: page,
            action: typeInfo.action,
            label: formatLabel(Odigeo._.get(typeInfo, LABEL), category, policy, pageLabel, this.variables),
        };
    }

    getNagTrackData(policy, action) {
        action = getActionWithSameTracking(action);

        const category = Odigeo._.get(this.ancillaryLabelCategoryByPolicy, policy);
        const trackObj = Odigeo._.cloneDeep(Odigeo._.get(this.eventsDictionary.nag, action));
        const page = this.getPageToTrack();
        const pageLabel = getPageLabel(page);

        for (const key in trackObj) {
            if (Object.prototype.hasOwnProperty.call(trackObj, key)) {
                if (Odigeo.AB.getSmartRejectionNag > 1 && (category === 'CANCASS' || category === 'CANC')) {
                    let newLabel = formatLabel(Odigeo._.get(trackObj[key], LABEL), category, policy, pageLabel, this.variables);
                    const labelParts = newLabel.split('_');
                    if (key === 'reject') {
                        newLabel = [...labelParts.slice(0, 4), key].join('_');
                    } else {
                        const lastPart = labelParts[labelParts.length - 1];
                        newLabel = [...labelParts.slice(0, 4), lastPart].join('_');
                    }
                    trackObj[key].label = 'smart_' + newLabel;
                } else {
                    trackObj[key].label = formatLabel(Odigeo._.get(trackObj[key], LABEL), category, policy, pageLabel, this.variables);
                }
            }
        }

        return trackObj;
    }

    initOnLoadProductsTrackingArray() {
        const ANCILLARY_CLASSES_EXPANDED_INTO_POLICIES = this.ancillaryLabelExpandedCategoriesIntoPolicies || [];
        this.onLoadProductsTrackingArray = prepareOnLoadTrackingArray(ANCILLARY_CLASSES_EXPANDED_INTO_POLICIES.length);
        this.waitingForOnLoadTracking = 0;
    }

    willTrackOnLoadOfSomeProducts() {
        this.waitingForOnLoadTracking++;
    }

    hasTrackedOnLoadOfSomeProducts() {
        this.waitingForOnLoadTracking--;
        if (this.waitingForOnLoadTracking < 0) {
            this.waitingForOnLoadTracking = 0;
        }
    }

    trackOfferedProducts(offeredProducts = [], getProductsFromSessionStorage = false, otherProducts = []) {
        if (!offeredProducts) {
            offeredProducts = [];
        }

        if (getProductsFromSessionStorage) {
            offeredProducts = getProductsFromSessionStorageByProductNameAndPage(this.getPageToTrack(), this.product) || [];
        }

        offeredProducts.push(...otherProducts);

        if (!Odigeo._.isArray(offeredProducts)) {
            offeredProducts = [];
        }

        for (let product of offeredProducts) {
            const policyCategory = this.ancillaryLabelCategoryByPolicy[product] || AncillariesTracking.UNKNOWN_CLASSES_ENUM.UNKNOWN;
            let productClassIndex = this.ancillaryLabelExpandedCategoriesIntoPolicies.indexOf(policyCategory);
            if (productClassIndex === -1) {
                productClassIndex = this.ancillaryLabelExpandedCategoriesIntoPolicies.indexOf(product);
            }

            this.onLoadProductsTrackingArray[productClassIndex] = ON_LOAD_TRACKING_DISPLAYED_VALUE;
        }

        this.hasTrackedOnLoadOfSomeProducts();

        if (this.waitingForOnLoadTracking === 0) {
            const trackString = this.onLoadProductsTrackingArray.join(ON_LOAD_JOIN_CHAR);
            this.onLoadProduct(trackString);
            this.initOnLoadProductsTrackingArray();
        }
    }

    registerOffer(policy) {
        trackingAncillariesContinuance.registerOfferedPolicy(this.product, policy, this.getPageToTrack());
    }

    prepareTrackEventFunction(type) {
        return Odigeo._.partial(this.trackEvent, type);
    }

    addOrRemoveProduct(policy, isAdded, isAfterForcedSelectionValidation) {
        policy = policy === NO_POLICY ? NO_PRODUCTS_TRACK : policy;
        const typeSuffix = isAfterForcedSelectionValidation ? '_after_mandatory' : '';
        const eventName = isAdded ? ADD_REMOVE_ENUM.add : ADD_REMOVE_ENUM.remove;
        const eventType = `${eventName}${typeSuffix}`;
        this.trackEvent(eventType, policy);
    }
}

AncillariesTracking.UNKNOWN_CLASSES_ENUM = new Odigeo.Enum(['UNKNOWN']);
AncillariesTracking.POLICY = '<policy>';
AncillariesTracking.CATEGORY = '<category>';
AncillariesTracking.PAGE = '<page>';
AncillariesTracking.PRICE_WITHOUT_INSURANCE = '<price_without_insurance>';
AncillariesTracking.PRICE_WITH_INSURANCE = '<price_with_insurance>';
AncillariesTracking.POLICY_REGEXP = new RegExp(AncillariesTracking.POLICY, 'g');
AncillariesTracking.CATEGORY_REGEXP = new RegExp(AncillariesTracking.CATEGORY, 'g');
AncillariesTracking.PAGE_REGEXP = new RegExp(AncillariesTracking.PAGE, 'g');
AncillariesTracking.prototype.onLoadProduct = AncillariesTracking.prototype.prepareTrackEventFunction('onload');
AncillariesTracking.prototype.addProduct = AncillariesTracking.prototype.prepareTrackEventFunction('add');
AncillariesTracking.prototype.removeProduct = AncillariesTracking.prototype.prepareTrackEventFunction('remove');
AncillariesTracking.prototype.openDetails = AncillariesTracking.prototype.prepareTrackEventFunction('open_details');
AncillariesTracking.prototype.closeDetails = AncillariesTracking.prototype.prepareTrackEventFunction('close_details');
AncillariesTracking.prototype.continue = AncillariesTracking.prototype.prepareTrackEventFunction('continue');
AncillariesTracking.prototype.addedBubble = AncillariesTracking.prototype.prepareTrackEventFunction('added_bubble');

module.exports = AncillariesTracking;
